import { createFeatureSelector, createSelector } from '@ngrx/store';
// import { HttpStatus } from '@core/classes/http-status.class';
import { HttpErrorResponse } from '@angular/common/http';

// import * as Objects from '@core/objects';
// import * as Access from '@app/models/access';
import { NotificationInterface } from '@core/store/models/notifications.interface';

export interface Notifications {
    items: NotificationInterface[]
}

export const initialState: Notifications = {
   items: []
};

const notificationsFeatureSelector = createFeatureSelector('notifications');

// Selectors
export const itemsSelector = createSelector(
    notificationsFeatureSelector,
    (state: Notifications) => state.items
);